import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/',
})

apiClient.interceptors.request.use(
  function(config) {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')

    if (params.has('token')) {
      params.delete('token')

      const url = location.pathname + (params.toString() ? '?' : '') + params
      window.history.replaceState({}, '', url)

      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

export default apiClient
